import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class SetAnsvarigAvverkningledareCommand extends BasicCommand<SetAnsvarigAvverkningledareCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    username: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetAnsvarigAvverkningledareCommand";
    constructor(init: (instance: SetAnsvarigAvverkningledareCommand) => void) {
        super("SetAnsvarigAvverkningledareCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
